import {
  DEFAULT_AUTH_ISSUER_PATH,
  DEFAULT_BACKEND_URL_PATH,
  DEFAULT_AE_BACKEND_URL_PATH,
} from "./const";

export const AUTH_ISSUER = (
  process.env.REACT_APP_AUTH_ISSUER || DEFAULT_AUTH_ISSUER_PATH
).replace(/\/+$/, "");

export const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL || DEFAULT_BACKEND_URL_PATH
).replace(/\/+$/, "");

export const AE_BACKEND_URL = (
  process.env.REACT_APP_AE_BACKEND_URL || DEFAULT_AE_BACKEND_URL_PATH
).replace(/\/+$/, "");

export const COMMIT_SHA = process.env.REACT_APP_COMMIT_SHA || "local-dev";

export const DEFAULT_AE_WIDGET_SRC =
  "https://cdn.geo.elelem.ai/answer-engine/dev/script_latest.js";

export const AE_WIDGET_SRC =
  process.env.REACT_APP_AE_WIDGET_SRC || DEFAULT_AE_WIDGET_SRC;

const extractHostname = (urlStr) => {
  try {
    return new URL(urlStr).hostname;
  } catch (e) {
    return "cdn.geo.elelem.ai";
  }
};

export const CDN_HOSTNAME = extractHostname(AE_WIDGET_SRC);

